import ItineratesDescription from 'features/WhatToDo/components/ItineratesDescription';
import React from 'react';

const Itineraries = (): JSX.Element => {
  return <ItineratesDescription />;
};

export default Itineraries;
